// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/labels/modules/labels-view-details/labels-view-details.less
// module id = 3705
// module chunks = 0